/** JSON_PATHS */
export const JSON_PATHS = {
    NIL: {
        SUBSCRIPTION: {},
        ORDER_DETAILS: {
            TARIFF_DETAILS: '$.subscriptionGroups.subscriptionGroup[0].subscriptions.subscription',
            TARIFF_SUBSCRIPTION: '$.subscriptions.subscription',
            BACK_END_ID: '$.backendId[0].value',
            POSTAL: '$.shipToContactPoints.postal',
            POSTALBILL: '$.billToContactPoints.postal',
            INDIVIDUAL: '$.shipToParty.individual',
            INDIVIDUALBILL: '$.billToParty.individual',
            TRACKING_LINK: '$.logistics.trackinglink',
            TRACKING_NUMBER: '$.logistics.trackingNumber',
            POSITION: '$.logistics.milestone.position',
            EMAIL: '$.contactPoints.email.fullAddress',
        },
        REASON_LIST: {
            LIST: '$.reasons.valueList',
        },
        LOGIN_AFTER_SUCCESS: {
            MAP_DELIVERY_STATUS: '$.logistics.milestone.position',
            MAP_PREVIOUS_TRANSACTION: '$.orderLineItems[0].previousTransactions',
        },
        PREVIOUS_TRANSACTIONS: {
            ARTICLE_NUMBER: (articleNumber) => `$..groups.*.*[?(@.position.articleNumber == '${articleNumber}')].position.previousTransactions`,
            ARTICLE_NUMBER_TRANSACTION_NAME: (articleNumber, transactionName) => `$..groups.*.['${transactionName}'][?(@.position.articleNumber == '${articleNumber}')].position.previousTransactions`,
            ARTICLE_NUMBER_TRANSACTION_NAME_IMEI: (articleNumber, transactionName, imei) => `$..groups.*.['${transactionName}'][?(@.position.articleNumber == '${articleNumber}' && @.position.imei === ${imei})].position.previousTransactions`,
            ARTICLE_NUMBER_IMEI: (articleNumber, imei) => `$..groups.*.*[?(@.position.articleNumber === '${articleNumber}' && @.position.imei == '${imei}')].position.previousTransactions`,
            GET_ALL_POSTION_WITH_TIMESTAMP: '$.*.*..*.position',
            FLATTEN_POSITION_IN_ARTICLENUMBER: '$.*.*',

        },
    },
};
